import type { RatingLevel } from "meetings/shared/constants";

/**
 * The four faces, best to worst read left to right
 * (ACTIONPLAN-RATING-ANSWERS-ARE-ONE-BASED-001), rendered by the shared
 * RatingToggle in the same circular-badge style as the meeting stoplights.
 */
export const ACTIONPLAN_RATING_LEVELS: RatingLevel[] = [
  {
    rating: 1,
    labelKey: "pages.actionplan.rating.good",
    icon: "fa-face-laugh-beam",
    activeBoxClass: "tw-bg-blue-200 tw-border tw-border-blue-300 tw-shadow-xs",
    activeIconClass: "tw-text-blue-500",
    barColorClass: "tw-bg-blue-500",
  },
  {
    rating: 2,
    labelKey: "pages.actionplan.rating.sufficient",
    icon: "fa-face-smile-beam",
    activeBoxClass:
      "tw-bg-green-200 tw-border tw-border-green-300 tw-shadow-xs",
    activeIconClass: "tw-text-green-500",
    barColorClass: "tw-bg-green-500",
  },
  {
    rating: 3,
    labelKey: "pages.actionplan.rating.moderate",
    icon: "fa-face-meh",
    activeBoxClass:
      "tw-bg-yellow-200 tw-border tw-border-yellow-300 tw-shadow-xs",
    activeIconClass: "tw-text-yellow-500",
    barColorClass: "tw-bg-yellow-500",
  },
  {
    rating: 4,
    labelKey: "pages.actionplan.rating.insufficient",
    icon: "fa-face-worried",
    activeBoxClass: "tw-bg-red-200 tw-border tw-border-red-300 tw-shadow-xs",
    activeIconClass: "tw-text-red-500",
    barColorClass: "tw-bg-red-500",
  },
];
